<section class="c-cover c-cover--reversed t-mark-grupo-c3" id="inicio">

  <div class="c-cover__image"></div>

  <span class="c-cover__title-qualifier">
    Redação Nota 1000
  </span>

  <h1 class="c-cover__main-title omega">
    Leve a redação dos seus alunos a um novo patamar, na prática!
  </h1>

  <div class="c-cover__controls">
    <button matRipple
            [routerLink]="['.']"
            fragment="recursos-exclusivos"
            id="btn-topm-entenda-escola"
            class="c-cover__button c-button c-button--large c-button--solid-reversed">
      Veja como funciona

      <fa-icon class="u-margin-left-small" [icon]="['fas', 'arrow-alt-circle-down']"></fa-icon>
    </button>
  </div>

</section>


<section class="c-home-section c-hub-grid t-primary"
         id="recursos-exclusivos">

  <h2 class="c-home-section__main-title">
    Recursos exclusivos
  </h2>

  <div class="c-home-section__intro">
    <p class="gamma">
      Disponível a partir do 6º ano do Ensino Fundamental, a ferramenta oferece
      diversos gêneros textuais e viabiliza, em especial, melhoras
      significativas nas notas de alunos do Ensino Médio no ENEM e vestibulares.
    </p>
  </div>


  <div class="c-hub-grid-item c-hub-grid-item--first">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">
        <fa-icon [icon]="['fas', 'history']"></fa-icon>
      </span>
      Tarefa de redação
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Programe e controle as tarefas de redação de suas turmas.
    Defina gêneros, temas e prazos. Acompanhe online a produção
    dos seus alunos, onde e quando desejar.
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--second">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">
        <fa-icon [icon]="['fas', 'table']"></fa-icon>
      </span>
      Banco de temas
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Centenas de temas de gêneros variados, prontos para aplicação.
    Quer usar um tema seu? Sem problema! Basta cadastrá-lo na plataforma.
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--third">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">
        <fa-icon [icon]="['fas', 'file-signature']"></fa-icon>
      </span>
      Manuscrito ou digitado
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Os alunos podem digitar suas redações no computador,
    tablet ou smartphone. Também é possível digitalizar ou fotografar
    redações manuscritas e enviar as imagens.
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--fourth">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">
        <fa-icon [icon]="['fas', 'user-graduate']"></fa-icon>
      </span>
      Correções detalhadas
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Na plataforma, professores-corretores experientes produzem avaliações
    super completas e comentadas, com notas detalhadas, utilizando
    nossa exclusiva ferramenta de correção.
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--fifth">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">
        <fa-icon [icon]="['fas', 'copy']"></fa-icon>
      </span>
      Recurso de reescrita
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Na modalidade de reescrita, as redações são avaliadas de forma comparada,
    mostrando ponto a ponto o que o aluno conseguiu melhorar
    de um texto para o outro.
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--sixth">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">
        <fa-layers>
          <fa-icon [icon]="['far', 'copy']"></fa-icon>
          <fa-icon [icon]="['fas', 'search']" transform="shrink-6 down-3.5 right-7"></fa-icon>
        </fa-layers>
      </span>
      Controle de plágio
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Plágio é assunto sério! Nas redações digitadas, conte com uma ferramenta
    automática para evitar a cópia completa ou de partes de textos da internet.
  </p>

  <div class="c-hub-grid__image">
    <img redLightbox
         imageUrl="assets/images/laudo-completo--full.png"
         src="assets/images/laudo-completo.png"
         alt="Exemplo de laudo / folha de correção de uma redação"
         id="click-laudoimg">
  </div>
</section>


<section class="c-impact c-home-section">

  <h2 class="c-home-section__main-title c-impact__main-title">
    Impacto
  </h2>

  <div class="c-home-section__intro c-impact__intro">
    <p class="gamma">
      Após cerca de 10 textos produzidos na plataforma, nossos alunos apresentam
      melhora média de 270 pontos! Muitos evoluem mais de 400 pontos,
      mudando efetivamente de patamar de escrita.
    </p>
  </div>

  <div class="c-impact__item c-impact__schools">
    <span class="c-impact__plus">+ de </span>
    <span class="c-impact__number">270 </span>
    <span class="c-impact__what">escolas atendidas</span>
  </div>

  <div class="c-impact__item c-impact__students">
    <span class="c-impact__plus">+ de </span>
    <span class="c-impact__number">700</span> mil
    <span class="c-impact__what">alunos participantes</span>
  </div>

  <div class="c-impact__item c-impact__essays">
    <span class="c-impact__plus">+ de </span>
    <span class="c-impact__number">1.3</span> milhões
    <span class="c-impact__what">de redações corrigidas</span>
  </div>

  <figure class="c-impact-graph">
    <div class="c-impact-graph__bar"></div><div class="c-impact-graph__bar"></div>
    <div class="c-impact-graph__bar"></div><div class="c-impact-graph__bar"></div>
    <div class="c-impact-graph__bar"></div><div class="c-impact-graph__bar"></div>
    <div class="c-impact-graph__bar"></div><div class="c-impact-graph__bar"></div>
    <div class="c-impact-graph__bar"></div><div class="c-impact-graph__bar"></div>
  </figure>

  <div class="c-impact__item c-impact__points">
    <span>
      <span class="c-impact__number">270</span>

      <span class="c-impact__what">/ 1000</span>
    </span>

    pontos
  </div>

</section>


<section class="c-testimonials c-home-section">

  <h2 class="c-home-section__main-title c-testimonials__main-title">
    Depoimentos
  </h2>

  <figure class="c-testimonials__item o-media o-media--small">

    <div class="c-testimonials__avatar o-media__img">
      <img src="assets/images/avatars/girl2.png"
           alt="avatar representando Nathália Rodrigues Chaves">
    </div>

    <blockquote class="c-testimonials__quote o-media__body">
      <div>
        <p>
          As correções da plataforma são feitas com base nas competências exigidas
          pelo ENEM, entre outros vestibulares, sempre a partir de temas
          que colaboram para a  construção de um repertório cultural bem variado.
          Outra vantagem importante é o recurso de reescrita, como uma forma
          do aluno rever e melhorar seu texto de acordo com as observações feitas
          pelos corretores.
        </p>

        <p>
          Quanto mais o aluno produz e pratica redação, mais ele fica confiante
          e seguro na construção de seu texto.
        </p>
      </div>

      <footer class="c-testimonials__footer">
        — <cite class="c-testimonials__author">Nathália Rodrigues Chaves</cite>, <br>
        <cite class="c-testimonials__company">
          Coordenadora Pedagógica <br>
          Colégio Marista São José – Rio de Janeiro/RJ
        </cite>
      </footer>
    </blockquote>
  </figure>

  <figure class="c-testimonials__item o-media o-media--small">
    <div class="c-testimonials__avatar o-media__img">
      <img src="assets/images/avatars/teacher1.png"
           alt="avatar representando Márcia Celestini Vaz">
    </div>

    <blockquote class="c-testimonials__quote o-media__body">
      <div>
        <p>
          Nós, e os alunos, gostamos bastante da correção, principalmente por conta
          da sinalização por ícones (bandeirinhas). Além disso, os comentários da
          ferramenta estimulam os debates em sala de aula, aumentando a interação
          entre alunos e professores.
        </p>

        <p>
          Começamos com algumas turmas e rapidamente estendemos para todo
          o ensino médio. Gostamos tanto dos resultados que implantamos também
          para o nono ano, para que eles já comecem a produzir redações e se
          preparem para o futuro. A Redação Nota 1000 contribui com nossas ações
          internas em quantidade, qualidade e o aluno tem um retorno muito bom.
        </p>
      </div>

      <footer class="c-testimonials__footer">
        — <cite class="c-testimonials__author">Márcia Celestini Vaz</cite>, <br>
        <cite class="c-testimonials__company">
          Coordenadora e Professora de Língua Portuguesa <br>
          Colégio Dante Alighieri – São Paulo/SP
        </cite>
      </footer>
    </blockquote>
  </figure>

  <figure class="c-testimonials__item o-media o-media--small">
    <div class="c-testimonials__avatar o-media__img">
      <img src="assets/images/avatars/boy1.png"
           alt="avatar representando Marcelo Bernardo">
    </div>

    <blockquote class="c-testimonials__quote o-media__body">
      <div>
        <p>
          A parceria com a plataforma Redação Nota 1000 contribuiu muito para
          o fortalecimento do trabalho de produção textual em nosso colégio.
          Com relatórios de correção bem direcionados e um tempo curto para a
          devolutiva individualizada dos textos dos alunos, otimizamos muito
          o nosso trabalho. E com um olhar de examinadores externos!
        </p>

        <p>
          O site é bastante objetivo e funcional. É muito fácil a criação
          de tarefas periódicas de produção textual e de reescrita.
        </p>
      </div>

      <footer class="c-testimonials__footer">
        — <cite class="c-testimonials__author">Marcelo Bernardo</cite>,
        <cite class="c-testimonials__company">
          Diretor <br>
          Colégio Eximius - Recife/PE
        </cite>
      </footer>
    </blockquote>
  </figure>
</section>


<section class="c-companies c-home-section">

  <header class="c-companies__header">
    <h2 class="c-home-section__main-title c-companies__main-title">
      Escolas e parceiros
    </h2>
  </header>

  <div class="c-companies__row">

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/escola-da-vila.png"
           alt="logo escola da vila">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/wr.png"
           alt="logo colégio WR">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/dante-alighieri.png"
           alt="logo colégio Dante Alighieri">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/darwin.png"
           alt="logo Darwin">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/anglo.png"
           alt="logo Anglo">
    </div>
  </div>

  <div class="c-companies__row">
    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/cei.png"
           alt="logo cei">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/notre-dame.png"
           alt="logo Notre Dame">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/objetivo-penha.png"
           alt="logo objetivo penha">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/damas.png"
           alt="logo colégio damas">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/salvatoriano-bom-conselho.png"
           alt="logo colégio salvatoriano bom conselho">
    </div>
  </div>

  <div class="c-companies__row">
    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/divino-salvador.png"
           alt="logo colégio divino salvador">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/batista-mineiro.png"
           alt="logo colégio batista mineiro">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/apoio.png"
           alt="logo colégio apoio">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/maxi.png"
           alt="logo maxi">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/graded.png"
           alt="logo graded">
    </div>
  </div>

  <div class="c-companies__row">
    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/descomplica.jpg"
           alt="logo descomplica">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/quero-bolsa.png"
           alt="logo quero bolsa">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/laplace.png"
           alt="logo laplace">
    </div>

    <div class="c-companies__item">
      <img class="c-companies__logo"
           src="assets/images/logos/mind-lab.png"
           alt="logo mind lab">
    </div>
  </div>

</section>


<section class="c-pilot c-home-section" id="piloto">

  <header class="c-pilot__header">
    <h2 class="c-home-section__main-title c-pilot__main-title">
      Quer saber mais?
    </h2>

    <div class="c-home-section__intro c-pilot__intro">
      <p class="gamma">
        Cadastre-se no formulário para saber mais e
        <strong>solicite um projeto piloto</strong> para sua escola.
      </p>
    </div>

    <p class="c-pilot__contact">
      <a href="mailto:contato@redacaonota1000.com.br"
         title="email de contato comercial"
         class="c-pilot__contact-item">
        <fa-icon class="c-pilot__icon"
                 [icon]="['fas', 'paper-plane']"
                 [fixedWidth]="true">
        </fa-icon>
        contato@redacaonota1000.com.br
      </a>

    </p>
  </header>

  <form class="c-pilot-form t-alert-info"
        [formGroup]="pilotForm"
        (ngSubmit)="submitPilotForm()">

    <mat-form-field class="c-pilot-form__control" appearance="outline">
      <mat-label>Nome</mat-label>

      <input matInput
             placeholder="Nome"
             formControlName="nome">

      <mat-error *ngIf="pilotForm.get('nome').hasError('required')">
        Digite seu nome
      </mat-error>
    </mat-form-field>

    <mat-form-field class="c-pilot-form__control" appearance="outline">
      <mat-label>Email</mat-label>

      <input matInput
             type="email"
             placeholder="Email"
             formControlName="email">

      <mat-error *ngIf="pilotForm.get('email').hasError('required')">
        Digite seu email para contato
      </mat-error>

      <mat-error *ngIf="pilotForm.get('email').hasError('pattern')">
        Digite um email de contato válido
      </mat-error>
    </mat-form-field>

    <mat-form-field class="c-pilot-form__control" appearance="outline">
      <mat-label>Telefone</mat-label>

      <input matInput
             [redInputMask]="phoneMask"
             placeholder="(99) 99999.9999"
             formControlName="telefone">

      <mat-error *ngIf="pilotForm.get('telefone').hasError('required')">
        Digite seu telefone de contato
      </mat-error>

      <mat-error *ngIf="pilotForm.get('telefone').hasError('pattern')">
        Digite um telefone de contato válido
      </mat-error>
    </mat-form-field>

    <mat-form-field class="c-pilot-form__control" appearance="outline">
      <mat-label>Qual o seu papel na escola?</mat-label>

      <mat-select placeholder="Selecione" formControlName="cargo">
        <mat-option *ngFor="let option of roleInSchoolOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="pilotForm.get('cargo').hasError('required')">
        Selecione uma das opções
      </mat-error>
    </mat-form-field>

    <mat-form-field class="c-pilot-form__control" appearance="outline">
      <mat-label>Nome da escola</mat-label>

      <input matInput
             placeholder="Nome da escola"
             formControlName="escola">

      <mat-error *ngIf="pilotForm.get('escola').hasError('required')">
        Digite o nome da escola para a qual deseja solicitar o piloto
      </mat-error>
    </mat-form-field>

    <mat-form-field class="c-pilot-form__control" appearance="outline">
      <mat-label>Tipo de Instituição de Ensino</mat-label>

      <mat-select placeholder="Tipo de Instituição de Ensino" formControlName="tipoEscola">
        <mat-option *ngFor="let option of schoolTypeOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="pilotForm.get('tipoEscola').hasError('required')">
        Selecione uma das opções
      </mat-error>
    </mat-form-field>

    <mat-form-field class="c-pilot-form__control" appearance="outline">
      <mat-label>Estado</mat-label>

      <mat-select placeholder="Estado" formControlName="uf">
        <mat-option *ngFor="let option of ufOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="pilotForm.get('uf').hasError('required')">
        Selecione o estado onde a escola se localiza
      </mat-error>
    </mat-form-field>

    <mat-form-field class="c-pilot-form__control" appearance="outline">
      <mat-label>Cidade</mat-label>

      <input matInput
             placeholder="Cidade"
             formControlName="municipio">

      <mat-error *ngIf="pilotForm.get('municipio').hasError('required')">
        Digite o nome da cidade onde a escola se localiza
      </mat-error>
    </mat-form-field>

    <button matRipple
            id="btn-experimente"
            class="c-button c-button--large c-button--solid c-pilot-form__button">
      Experimente
    </button>
  </form>

</section>
